import { Box } from "@mui/system";

export const BaseLayout = ({ pageTitle, children, isLogout }) => {
  return (
    <>
      <title>{pageTitle} | Consignet & Mixtra</title>

      <Box
        component="main"
        width="100vw"
        height="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        px={4}
        sx={{
          backgroundImage: 'url("/images/dash-background.svg")',
          backgroundSize: "cover",
        }}
      >
        {!isLogout && (
          <Box 
            component="img" 
            src="/images/logo-consignet.svg" 
            alt="Logo Consignet" 
            width={272} 
          />
        )}
        {children}
        {!isLogout && (
          <Box 
            component="img" 
            src="/images/logo-mixtra.svg" 
            alt="Logo Mixtra" 
            width={186} 
          />
        )}
      </Box>
    </>
  );
};
